const footer = {
	ui: {},

	init: function() {
		this.bindUI();
		this.bindEvents();
	},

	bindUI: function bindUI() {
		this.ui.$columnToggle = $(".js-footer-title");
	},

	bindEvents: function bindEvents() {
		this.ui.$columnToggle.on('click', this.handleColumn.bind(this));
	},

    handleColumn: function(e) {
		if (window.innerWidth < 768) {
			e.preventDefault()

			let $this = $(e.currentTarget);
			const content = $this.parent().find('.js-footer-content')

			if (!$this.hasClass('--active')) {
				$('.js-footer-content').slideUp()
				$('.js-footer-title.--active').removeClass('--active')

				content.slideDown()
				$this.addClass('--active')
			} else {
				content.slideUp()
				$this.removeClass('--active')
			}
		}
    },

};

export default footer;
